import React from 'react';
import moment from 'moment';
import Grid from '@material-ui/core/Grid';
import classes from './Notification.module.css';
import { getTime,isRecentNotification } from './notificationutils';
import { getKneuraId, setBoardInfo } from '../../utils/authentication-access';
import { withTranslation } from 'react-i18next';

class EndClassNotification extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			notificationtime: "Just Now",
			isNew : false
		};
	}

	componentDidMount() {
		this.setState({ notificationtime: getTime(this.props.info.createdAt) });
		this.setState({ isNew: isRecentNotification(this.props.info.createdAt) });
		
	}


	render() {
		const { t } = this.props;
		return (
			<div className={classes.MesGrid}>
				<Grid container direction="row" justify="space-between" alignItems="flex-start" wrap="nowrap">
					<div className={ this.state.isNew ? classes.newNotificationMesHeader : classes.notificationMesHeader}>{this.props.info.className}</div>
					<div className={ this.state.isNew ? classes.newNotificationDateMesHeader:classes.notificationDateMesHeader}>{this.state.notificationtime}</div>
				</Grid>
				<div className={classes.notificationMes} >
					<b>{this.props.info.teacherName} </b> {t("is ended a live class")} <b>{this.props.info.whiteboardName}</b>
					{/* <p>{t("Click to join now")}</p> */}
				</div>
				<div className={this.state.isNew ? classes.NewMesDivider : classes.MesDivider} />
			</div>
		);
	}
}

export default withTranslation()(EndClassNotification);
